import { render, staticRenderFns } from "./PFLoanDocumentsFront.vue?vue&type=template&id=573d5997"
import script from "./PFLoanDocumentsFront.vue?vue&type=script&lang=js"
export * from "./PFLoanDocumentsFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports